import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { AuthProvider } from "./lib/auth";
import RouteSeo from "./components/feature/RouteSeo";

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AuthProvider>
        <RouteSeo />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
